var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "change--wrapper",
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 10, md: 24, xl: 10 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "card--box content-card-box",
                  style: "height: 286px",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header--title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v(_vm._s(_vm.$t("stores::products-info::base_attr")))]
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "basicForm",
                      staticStyle: { padding: "16px" },
                      attrs: {
                        model: _vm.detailForm,
                        "label-position": "left",
                        "label-width": "100px",
                      },
                    },
                    [
                      _c("el-form-item", { attrs: { label: "SPU：" } }, [
                        _vm._v(_vm._s(_vm.detailForm.id)),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::name") + "：",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.detailForm.title) + " ")]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system::responsible::供应商") + "：",
                          },
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _vm._v(" " + _vm._s(_vm.detailForm.supplier) + " "),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("stores::products-info::category") + "：",
                          },
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.detailForm.categoryNames) + " "
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("stores::products-info::currency") + "：",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.detailForm.spuCurrency) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 14, md: 24, xl: 14 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "card--box",
                  attrs: {
                    title: _vm.$t("stores::products-info::goods_detail"),
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header--title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("stores::products-info::goods_detail"))
                      ),
                    ]
                  ),
                  _vm.detailForm.spuLongDesc
                    ? _c("div", [
                        _c("div", {
                          staticStyle: { height: "198px", overflow: "auto" },
                          domProps: {
                            innerHTML: _vm._s(_vm.detailForm.spuLongDesc),
                          },
                        }),
                      ])
                    : _c("default-data", { staticStyle: { height: "198px" } }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-card",
            { staticClass: "card--box img-content-wrapper content-card-box" },
            [
              _c(
                "div",
                {
                  staticClass: "header--title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("商品信息")]
              ),
              _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v("商品图片"),
              ]),
              _c(
                "div",
                { staticClass: "image-list" },
                _vm._l(_vm.detailForm.spuImages, function (item, index) {
                  return _c("ZImg", {
                    key: index,
                    staticClass: "images",
                    attrs: { src: item },
                  })
                }),
                1
              ),
              _c("z-table", {
                ref: "skuTable",
                staticStyle: { "margin-top": "24px" },
                attrs: {
                  data: _vm.detailForm.skus,
                  "max-height": 300,
                  pagination: false,
                  columns: _vm.skuTableColumns,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "imageUrl",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("ZImg", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: { src: row.imageUrl },
                          }),
                        ]
                      },
                    },
                    {
                      key: "weight",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            _vm._s(_vm.$dataCheck(row.weight)) +
                              _vm._s(row.weightUnit)
                          ),
                        ]
                      },
                    },
                    {
                      key: "purchasePrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.purchasePrice))),
                        ]
                      },
                    },
                    {
                      key: "compareAtPrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.compareAtPrice))),
                        ]
                      },
                    },
                    {
                      key: "salePrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.$dataCheck(row.salePrice)))]
                      },
                    },
                    {
                      key: "safeInventory",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.safeInventory))),
                        ]
                      },
                    },
                    {
                      key: "skuInventory",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm.$dataCheck(row.skuInventory))),
                        ]
                      },
                    },
                    _vm._l(_vm.selectedSkuOpt, function (val, index) {
                      return {
                        key: val.label,
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", { key: index }, [
                              _vm._v(
                                " " + _vm._s(row.options[index].value) + " "
                              ),
                            ]),
                          ]
                        },
                      }
                    }),
                    {
                      key: "options",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            _vm._l(row.options, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "option-list" },
                                [
                                  _c("div", [_vm._v(_vm._s(item.name))]),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.$dataCheck(item.value))),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }